/**
 * Definition of the AccountUtil instance.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import { baseURL } from './env'
import { getAccountUtil } from '@amplify3/duplo-back-end'
export const accountUtil = getAccountUtil(baseURL)
